import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
//import { AppInsightsService, SeverityLevel } from '@markpieszak/ng-application-insights';
import { AppUrls } from '../../utility/appurls';

import { AppInsightsService } from '../../logging/app-insights-service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  imports: [RouterModule],
})
export class NotFoundComponent implements OnInit {
  private router = inject(Router);
  private appInsightsService = inject(AppInsightsService);
  homeUrl: string;

  
 

  //constructor(private appInsightsService: AppInsightsService, private router: Router) {
  constructor() {
    this.homeUrl = AppUrls.home();
  }

  ngOnInit() {
    this.appInsightsService.trackTrace('Attempted to navigate to page that was not found. URL: ' + this.router.url);
    
    // this.appInsightsService.trackException(
    //   new Error('Attempted to navigate to page that was not found. URL: ' + this.router.url),
    //   null,
    //   null,
    //   null,
    //   SeverityLevel.Information,
    // );
  }
}
